export function celsiusToFahrenheit(temp) {
  return temp * 1.8 + 32;
}

export function metersToFeet(m) {
  return m * 3.28084;
}

export function mmToInches(mm) {
  return mm * 0.0393701;
}

export function kmphToMph(kmph) {
  return kmph * 0.621371;
}
